import { useNavigate } from 'react-router-dom';
import PublicLegalPage from '@/components/PublicLegalPage';
import { PUBLIC_CORE_LINK_LABELS, TERMS_PAGE_CONTENT } from '../../ui-foundation';

export default function TermsPage() {
  const navigate = useNavigate();

  return (
    <PublicLegalPage
      title={TERMS_PAGE_CONTENT.title}
      subtitle={TERMS_PAGE_CONTENT.subtitle}
      introBody={TERMS_PAGE_CONTENT.introBody}
      sections={TERMS_PAGE_CONTENT.sections}
      actions={[
        { label: PUBLIC_CORE_LINK_LABELS.privacy, onPress: () => navigate('/privacy'), tone: 'outline' },
        { label: PUBLIC_CORE_LINK_LABELS.gdpr, onPress: () => navigate('/gdpr'), tone: 'outline' },
        {
          label: PUBLIC_CORE_LINK_LABELS.communityGuidelines,
          onPress: () => navigate('/community-guidelines'),
          tone: 'outline',
        },
        { label: PUBLIC_CORE_LINK_LABELS.contactSupport, onPress: () => navigate('/contact-complaints'), tone: 'outline' },
      ]}
    />
  );
}
